import { useState } from "react";
import { WindowSize } from "./WindowSize.js";
import { getWindowSize } from "./getWindowSize.js";
import { useEventListener } from "../event/useEventListener.js";

/**
 * Returns window size (body element clientWidth and clientHeight).
 */
export const useWindowSize = (): WindowSize => {
  const [size, setSize] = useState<WindowSize>(getWindowSize());

  useEventListener("resize", () => setSize(getWindowSize()), window);

  return size;
};
